import React from "react";
import BasicModal from "../../core/BaseComponents/Modal";
import deleteImg from '../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";

function DeleteMasterApkProviderConfig(props) {

  return (
    <BasicModal
      popupOpen={props?.deletePartnerPopUp}
      bodyMessage={<>
        <img src={deleteImg} alt="approve" className="w-40px" />
        <div className="delete-hotel mb-3">{props?.isPartnerDeletedRef.current?.isPartnerDeletedModalData ?
          <div className="confirm-delete-hotel">
            <p>Do you really want to Delete APK Provider Configuration "<b>{props?.isPartnerDeletedRef.current?.isPartnerDeletedModalData.row.appName}</b>" ?</p>
            <p className="warning"><IoMdWarning /> Warning</p>
            <p>APK Provider Configuration "{props?.isPartnerDeletedRef.current?.isPartnerDeletedModalData.row.appName}" will be permanently deleted <br />
              Deleting the specified APK Provider Configuration can't be undone.
            </p>
            <p className="mt-3">To confirm deletion, type "Delete {props?.isPartnerDeletedRef.current?.isPartnerDeletedModalData.row.appName}"</p>
            <div className="form-group-hotel mt-3">
              <div className="floating-label">
                <input
                  id="deleteHotel"
                  placeholder=''
                  onChange={(e) => props?.setConfirmDeletePartnerRow(e.target.value)}
                />
                <label htmlFor="deleteHotel">Delete {props?.isPartnerDeletedRef.current?.isPartnerDeletedModalData.row.appName}</label>
              </div>
              {(props?.confirmDeletePartnerRow === "" && props?.confirmValidate) ? (
                <p className="text-start"><small className="required">Please Enter Delete {props?.isPartnerDeletedRef.current?.isPartnerDeletedModalData.row.appName}</small></p>
              ) : (props?.confirmDeletePartnerRow !== `Delete ${props?.isPartnerDeletedRef.current?.isPartnerDeletedModalData.row.appName}` && props?.confirmValidate) ? (
                <p className="text-start"><small className="required">Please Enter Delete {props?.isPartnerDeletedRef.current?.isPartnerDeletedModalData.row.roomType}</small></p>
              ) : ""
              }
            </div>
          </div> :
          props?.isPartnerDeletedRef.current?.userConformationModalData?.successMessage}</div>
      </>
      }
      footer={
        props?.isPartnerDeletedRef.current?.isPartnerDeletedModalData ?
          {
            primaryButton: {
              buttonName: "Cancel",
              action: props?.popupCloseHandler
            }
            ,
            secondaryButton: {
              buttonName: "Delete",
              action: props?.deletePartnerHandler
            }
          } : {
            secondaryButton: {
              buttonName: "OK",
              action: props?.popupCloseHandler
            }
          }
      }
    />
  );
}

export default DeleteMasterApkProviderConfig;
